<template>
 <b-form @submit.prevent= validateBeforeSubmit>
   <option v-for="direccion in direcciones" v-bind:key="direccion.id">
           {{ direccion.Nombre }}
   </option>
  <b-row>
     <b-form-group>
          <b-form-checkbox
          v-model="indexSelected"
          ></b-form-checkbox>
        {{ direccion.Nombre }}
        {{ direccion.Direccion }}
      </b-form-group>
  </b-row>
 </b-form>
</template>

<script>
import {mapMutations, mapActions} from 'vuex'
 export default {
  props: {
    direccion: {
      type: Object,
      required: true
    },
    index:{
      type: Number,
      required: true

    } },
    methods: {
       validateBeforeSubmit() {
           this.$emit('processAddress', this.direccion)
        },
      ...mapMutations('addresses',['setAddress']),
      goToUpdateAddress() {
        this.setAddress(this.address)
        this.$router.push({
          name: 'address-update',
          params: {id: this.address.id}
        })
      }
    },
    data () {
      return {
        indexSelected: null
      }
    }
 }

</script>
